// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"aa7daa37","112":"3868f7e0","124":"8df37bb9","384":"857e7032","453":"d495d3d9","465":"d8666289","582":"054183de","583":"69a53ed6","694":"e8d53b2c","848":"329956e8","916":"474efa84"}[chunkId] + ".chunk.js";
};